import { render } from "./demoModal.vue?vue&type=template&id=298ac21b&scoped=true"
import script from "./demoModal.vue?vue&type=script&lang=js"
export * from "./demoModal.vue?vue&type=script&lang=js"

import "./demoModal.vue?vue&type=style&index=0&id=298ac21b&scoped=true&lang=css"
import "./demoModal.vue?vue&type=style&index=1&id=298ac21b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298ac21b"]])

export default __exports__